<div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">Număr contract: {{contract.number}}</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">
    <form [formGroup]="extendsValidityForm" class="needs-validation" novalidate>
        <div class="form-group row">
            <div class="col-xl col-md">
                <label>Valabil de la:</label>
                <input class="form-control" type="date" formControlName="contractStartingDate" onkeydown="return false" />
            </div>
            <div class="col-xl col-md">
                <label>Valabil pana la:</label>
                <input class="form-control" type="date" formControlName="expirationDate" onkeydown="return false" />
            </div>
        </div>
        <div class="row justify-content-center">
            <button type="button" class="btn btn-primary mr-1" (click)="save()">Salveaza</button>
        </div>
    </form>
</div>